import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { Star, ArrowRight } from 'lucide-react';
export function HeroSection() {
  const CART_URL = 'https://pagos.avanzalab.online/cart/52985716146490:1';
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-[#0a0a0a] pb-12" data-id="element-96">
      {/* Urgency Bar */}
      <div className="w-full bg-red-700 text-white py-2 px-3 text-center font-bold text-xs md:text-sm sticky top-0 z-40 shadow-md" data-id="element-97">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-center items-center gap-1.5" data-id="element-98">
          <span data-id="element-99">OFERTA ESPECIAL DE LANZAMIENTO – 56% OFF SOLO POR HOY</span>
          <div className="flex items-center bg-red-900 px-2 py-0.5 rounded" data-id="element-100">
            <span className="mr-1.5 text-[10px] uppercase tracking-wider" data-id="element-101">
              Finaliza en:
            </span>
            <CountdownTimer className="text-white text-sm" size="sm" data-id="element-102" />
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 pt-8 md:pt-12 text-center" data-id="element-103">
        {/* Main Headline */}
        <h1 className="text-4xl md:text-6xl font-black text-white leading-tight mb-8 uppercase tracking-tight" data-id="element-104">
          De 0 a tu primer trabajo cobrado aplicando{' '}
          <span className="text-amber-500" data-id="element-105">pisos epoxi</span> en Argentina
        </h1>

        {/* Product Image - Clickable */}
        <div className="mb-8 cursor-pointer hover:scale-[1.02] transition-transform duration-300" onClick={scrollToPurchase} data-id="element-106">
          <img src="https://cdn.magicpatterns.com/uploads/xsbxEdh9ZjbDfwBURenJQx/87fe5c4a-27a8-4673-8c22-b0bb6b4c0068.png" alt="Mega Pack Pisos Epoxi Pro Desde Cero" className="w-full max-w-2xl mx-auto drop-shadow-[0_0_40px_rgba(201,168,76,0.3)]" data-id="element-107" />
        </div>

        {/* Subtitle */}
        <p className="text-xl md:text-2xl text-gray-300 font-medium mb-4 max-w-3xl mx-auto" data-id="element-108">
          Aprendé a aplicar, cotizar y convertir esto en un emprendimiento
          rentable en un mercado que no para de crecer.
        </p>

        <p className="text-lg text-amber-400 mb-8 font-semibold" data-id="element-109">
          Incluye 3 bonos estratégicos para acelerar tus ingresos.
        </p>

        {/* Divider */}
        <div className="w-24 h-1 bg-amber-600/40 mx-auto mb-8" data-id="element-110"></div>

        {/* Social Proof */}
        <div className="flex items-center justify-center gap-2 mb-8 bg-amber-900/20 py-3 px-6 rounded-full inline-flex mx-auto border border-amber-700/40" data-id="element-111">
          <div className="flex text-amber-500" data-id="element-112">
            <Star className="w-5 h-5 fill-current" data-id="element-113" />
            <Star className="w-5 h-5 fill-current" data-id="element-114" />
            <Star className="w-5 h-5 fill-current" data-id="element-115" />
            <Star className="w-5 h-5 fill-current" data-id="element-116" />
            <Star className="w-5 h-5 fill-current" data-id="element-117" />
          </div>
          <span className="font-bold text-gray-200" data-id="element-118">
            +1200 personas ya aplicaron este sistema
          </span>
        </div>

        {/* Mid-section CTA */}
        <a href={CART_URL} className="w-full md:w-auto bg-amber-500 hover:bg-amber-400 text-black text-xl md:text-2xl font-bold py-4 px-8 rounded-lg shadow-lg shadow-amber-500/20 hover:shadow-xl hover:shadow-amber-400/30 transition-all transform hover:-translate-y-1 flex items-center justify-center mx-auto gap-3 animate-pulse" data-id="element-119">
          🔥 QUIERO EMPEZAR AHORA – 56% OFF
          <ArrowRight className="w-6 h-6" data-id="element-120" />
        </a>
      </div>
    </section>;
}